import { useEffect } from 'react'
import { useSignal, batch } from '@preact/signals-react'
import { postSubmit } from '@ui-seeker/utils'

import { isLoadingCommonFilters, commonFiltersValue, isSystemBusy } from '@signals'
import { WEBBACK_V2_API } from '@constants'
import { shareOfSearchStatusIsEmpty } from "../@signals";


export default function useShareOfSearchStatusFilters() {

    const data = useSignal([])

    useEffect(() => {
        if (isLoadingCommonFilters.value) batch(() => {
            postSubmit(`${WEBBACK_V2_API}/share-of-search/keyword-status/context`, commonFiltersValue.value)
                .then(res => {
                    if (!res?.length)
                        shareOfSearchStatusIsEmpty.value = true
                    data.value = res
                    isLoadingCommonFilters.value = false
                })
                .catch(() => {
                    isSystemBusy.value = true
                    isLoadingCommonFilters.value = false
                })
        })
    }, [isLoadingCommonFilters.value])

    return {
        data: data.value
    }
}